export default __webpack_public_path__ + "static/media/upload.7dcf1f38.svg";